import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_LINK_HOST } from '@/lib/constants';

// Listens for Universal Link / App Link opens (and, if ever registered, custom
// URL scheme opens) and routes them through the in-app router so the
// destination page loads inside the app instead of dropping the user on the
// splash. Wired in App so useNavigate is available.
export function DeepLinkListener() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!(window as any).Capacitor) return;

    let cleanup: (() => void) | undefined;

    import('@capacitor/app')
      .then(({ App }) => {
        const handle = App.addListener('appUrlOpen', ({ url }) => {
          try {
            const parsed = new URL(url);
            // Only handle links we own.
            if (parsed.host && parsed.host !== APP_LINK_HOST) return;

            const target = parsed.pathname + parsed.search + parsed.hash;
            if (target && target !== '/') navigate(target);
          } catch (err) {
            console.warn('Ignoring malformed appUrlOpen:', url, err);
          }
        });

        cleanup = () => {
          handle.then((h) => h.remove()).catch(() => {});
        };
      })
      .catch((err) => {
        console.warn('Failed to load @capacitor/app:', err);
      });

    return () => {
      cleanup?.();
    };
  }, [navigate]);

  return null;
}
